const CreateTradeAccount = () => import('./auth/CreateTradeAccount');
Vue.component('CreateTradeAccount', CreateTradeAccount);

const CreateTradeOrder = () => import('./order/CreateTradeOrder');
Vue.component('CreateTradeOrder', CreateTradeOrder);

const BdmNewsForm = () => import('./bdm/BdmNewsForm');
Vue.component('BdmNewsForm', BdmNewsForm);
